import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">热门话题</h2>
          <span className="text-xs text-foreground-500 mt-1 whitespace-nowrap">大家都在搜</span>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className={`group cursor-pointer px-4 py-2.5 rounded-full border transition-all flex items-center gap-2 whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100 border-accent-300 text-accent-700 hover:bg-accent-200'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:border-background-300'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-accent-500' : 'text-foreground-400'}`}>{topic.count}</span>
              {topic.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}